import { mount } from "@vue/test-utils";
import DniTramiteInput from "@/components/core/composite/DniTramiteInput";

describe("DniTramiteInput component", () => {
  let wrapper;
  it("renderiza componente DniTramiteInput con su componente hijo NumberInput", () => {
    const valueToText = "myValue";
    wrapper = mount(DniTramiteInput, {
      propsData: {
        label: "labelValue",
        value: valueToText,
        placeholder: "placeholderValue",
        hint: "hint",
        required: true,
        maxlength: "10",
        name: "nameValue"
      }
    });

    const NumberInput = wrapper.findComponent({ name: "NumberInput" });
    const propValue = NumberInput.props("value");
    expect(propValue).toBe(valueToText);
  });
});
